import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Form, Button, Select, Input, Typography} from 'antd';
import pencils from '../../assets/pngs/pencils.png';
import Google from '../../components/Google/Google';
import Logo from '../../components/Logo/Logo';
import FormInput from '../../components/Form/FormInput';
import userStore from '../../zustand/store/userStore';

const { Title, Text } = Typography;

const Signup = () => {
	const Navigate = useNavigate();
	const [file, setFile] = useState(null);
	const [preview, setPreview] = useState(null);
	const [loading, setLoading] = useState(false);
	const { data, authToken, userSignup,resetState } = userStore();

	useEffect(() => {
		if (data?.otpSend) {
			Navigate('/otp-verify');
			resetState();
		}
	}, [authToken, data, Navigate]);
	const onFinish = async (values) => {
		setLoading(true);
		const formData = new FormData();
		formData.append('fullName', values.fullName);
		formData.append('email', values.email.toLowerCase());
		formData.append('password', values.password);
		formData.append('parentEmail', values.parentEmail.toLowerCase());
		formData.append('grade', values.grade);
		formData.append('role', 'student');

		if (file) {
			formData.append('profilePic', file);
		}

		await userSignup(formData);
		setLoading(false);
	};


	return (
		<div className="w-screen h-screen flex items-center justify-center bg-[#F6F6F6]">
			<div className="w-full h-full flex flex-col md:flex-row shadow-lg overflow-hidden">
				<div className="w-full md:w-1/2 px-4 md:px-6 py-4 flex flex-col justify-center items-center max-h-screen overflow-hidden">
					<div className="flex justify-center mb-3">
						<Logo />
					</div>

					<h2 className="text-lg md:text-xl font-semibold text-center mb-3">
						Join our community
					</h2>

					<Form
						name="signup"
						onFinish={onFinish}
						className="w-full max-w-[300px] space-y-3"
						initialValues={{ remember: true }}
					>
						<Form.Item className="flex justify-center mb-1">
							<div className="w-16 h-16 rounded-full overflow-hidden border-2 border-dashed border-gray-300 flex items-center justify-center relative">
								{preview ? (
									<img src={preview} alt="Preview" className="w-full h-full object-cover" />
								) : (
									<svg
										className="w-6 h-6 text-gray-400"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M3 7h2l2-3h10l2 3h2a2 2 0 012 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V9a2 2 0 012-2zm9 3a4 4 0 100 8 4 4 0 000-8z"
										/>
									</svg>
								)}
								<input
									type="file"
									accept="image/*"
									className="absolute inset-0 opacity-0 cursor-pointer"
									onChange={(e) => {
										const selectedFile = e.target.files[0];
										if (selectedFile) {
											setFile(selectedFile);
											setPreview(URL.createObjectURL(selectedFile));
										}
									}}
								/>
							</div>
						</Form.Item>


						<FormInput name="fullName" placeholder="Full Name*" width={'100%'} className="text-sm" />
						<FormInput name="email" placeholder="Email*" type="email" width={'100%'} className="text-sm" />
						<FormInput name="password" placeholder="Password*" type="password" width={'100%'} className="text-sm" />

						<Form.Item
							name="parentEmail"
							rules={[
								{ required: true, message: 'Please enter parent email!' },
								({ getFieldValue }) => ({
									validator(_, value) {
										if (value && value === getFieldValue('email')) {
											return Promise.reject('Student Email and Parent Email cannot be the same!');
										}
										return Promise.resolve();
									},
								}),
							]}
						>
							<Input
								type="email"
								placeholder="Parent Email*"
								className="p-2 text-sm border border-gray-300 rounded"
							/>
						</Form.Item>

						<Form.Item
							name="grade"
							label={<span className="text-sm font-medium">Grade</span>}
							className="mb-2"
							rules={[{ required: true, message: 'Please select your grade!' }]}
						>
							<Select placeholder="Select Grade" className="w-full text-sm rounded-md">
								<Select.Option value="9">9</Select.Option>
								<Select.Option value="10">10</Select.Option>
								<Select.Option value="11">11</Select.Option>
								<Select.Option value="12">12</Select.Option>
							</Select>
						</Form.Item>

						<Form.Item className="mb-1">
							<Button
								htmlType="submit"
								block
								loading={loading}
								className="bg-green-600 hover:bg-green-700 text-white py-2 text-sm rounded"
							>
								Sign Up
							</Button>
						</Form.Item>

						<p className="text-center text-xs">
							Already have an account?{' '}
							<span
								onClick={() => Navigate('/login')}
								className="text-green-600 cursor-pointer hover:underline"
							>
								Sign In
							</span>
						</p>
					</Form>
					<div className="mt-2">
						<Google />
					</div>
				</div>



				<div className="hidden md:flex w-1/2 h-full bg-gray-100 items-center justify-center">
					<img src={pencils} alt="Pencils" className="w-full h-full" />
				</div>
			</div>
		</div>
	);
};

export default Signup;
